module.exports = __webpack_public_path__ + "static/media/N2.7c3ac370.jpg";